import React, { useState, useEffect, useCallback } from 'react';
import PinDialog from '../components/PinDialog';
import { useLocation } from 'react-router-dom';

const Home: React.FC = () => {
    const [pinDialogOpen, setPinDialogOpen] = useState(true);
    const location = useLocation();

    useEffect(() => {
        setPinDialogOpen(true);
    }, [location.search]);

    // Stable reference — prevents PinDialog's skipToPlay from being recreated on
    // every Home render, which was causing the auto-login effect to fire repeatedly
    // and potentially call navigate('/play') more than once before unmount
    const handlePinDialogClose = useCallback(() => {
        setPinDialogOpen(false);
    }, []);

    return (
        <div style={{ backgroundColor: 'black', height: '100vh', width: '100vw' }}>
            <PinDialog
                open={pinDialogOpen}
                onClose={handlePinDialogClose}
            />
        </div>
    );
};

export default Home;